import React, { useEffect } from "react";
import PropTypes from "prop-types";
import style from "./sliding-view.css";

function SlidingView({ index, children }) {
    const nodeRef = React.createRef();
    useEffect(() => {
        nodeRef.current.style.transform = `translateX(${index * -100}%)`;
    });

    return (
        <div ref={nodeRef} className={style.slideContainer}>
            {children}
        </div>
    );
}

export default SlidingView;

SlidingView.propTypes = {
    index: PropTypes.number.isRequired,
    children: PropTypes.node.isRequired
};
